import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class PrivateHireSection {
	constructor(elm) {
		this.elm = elm;

		this.initHeaderAnimation();
        this.initSegments();
	}

	initHeaderAnimation() {
        this.headerImage = this.elm.querySelector('[data-header-image]');

        this.headerImageDummy = this.elm.querySelector('[data-header-image-dummy]');
        if(!this.headerImage) {
            return;
        }

        this.headerImageImg = this.headerImage.querySelector('.img');
        if(!this.headerImageImg) {
            return;
        }

        this.tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.headerImageDummy,
                start: "bottom bottom-=24",
                endTrigger: this.headerImage,
                end: "bottom bottom-=24",
                //scrub: true
            }
        });

        this.tl.to(this.headerImageImg, {
            scale: 1,
            duration: 2,
            ease: 'power2.inOut',
        });

	}

    initSegments() {
        this.segmentsElm = this.elm.querySelector('[data-segments]');
        if(this.segmentsElm) {
            this.segmentLinks = this.segmentsElm.querySelectorAll('[data-segment-link]');
            this.segements = this.segmentsElm.querySelectorAll('[data-segment]');

            this.segmentLinks.forEach(link => {

                const linkOffset = link.getBoundingClientRect().top-this.segmentsElm.getBoundingClientRect().top;
                const targetID = link.getAttribute('href');
                const targetSegment = this.segmentsElm.querySelector('[data-segment="'+targetID+'"]');

                gsap.set(targetSegment, {
                    marginTop: linkOffset+'px'
                });

                link.addEventListener('click', evt => {
                    evt.preventDefault();
                    this.activateSegment(link, targetSegment);
                });
            });
        }
    }

    activateSegment(link, segment) {
        this.segmentLinks.forEach(link => {
            link.classList.remove('is-active');
        })
        link.classList.add('is-active');

        this.segements.forEach(segment => {
            segment.classList.remove('is-active');
        })
        segment.classList.add('is-active');
    }

    destroy() {
        //
	}

}
